// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".validation-container{min-height:24px}\n", "",{"version":3,"sources":["/app/src/component/common/validation-message/validationMessageStyle.scss"],"names":[],"mappings":"AAAA,sBACE,eAAgB","file":"validationMessageStyle.scss","sourcesContent":[".validation-container {\n  min-height: 24px;\n}\n"]}]);
// Exports
module.exports = exports;
